import { useEffect, useState } from "react";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { conversationSearchApi } from "@/modules/sales/search/api/search.api";
import type { SearchInput } from "@/modules/sales/search/types";

export const searchKeys = {
  all: ["sales", "search"] as const,
  search: (input: SearchInput) => ["sales", "search", "results", input] as const,
  suggestions: (q: string) => ["sales", "search", "suggestions", q] as const,
};

/**
 * Universal conversation search — debounced.
 * Query bo'sh yoki <2 belgi bo'lsa request yubormaydi (filter-only ham keyingi
 * iteratsiyada qo'shiladi).
 */
export function useSearch(
  input: SearchInput,
  options: { debounceMs?: number; minLength?: number; enabled?: boolean } = {},
) {
  const { debounceMs = 300, minLength = 2, enabled = true } = options;
  const [debounced, setDebounced] = useState(input.query);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(input.query), debounceMs);
    return () => clearTimeout(t);
  }, [input.query, debounceMs]);

  const isReady = enabled && debounced.trim().length >= minLength;

  const effectiveInput: SearchInput = {
    ...input,
    query: debounced.trim(),
  };

  return useQuery({
    queryKey: searchKeys.search(effectiveInput),
    queryFn: () => conversationSearchApi.search(effectiveInput),
    enabled: isReady,
    staleTime: 30_000,
    placeholderData: keepPreviousData,
  });
}
